import { render, staticRenderFns } from "./TotalSalesRevenue.vue?vue&type=template&id=08eb81f4&scoped=true&"
import script from "./TotalSalesRevenue.vue?vue&type=script&lang=js&"
export * from "./TotalSalesRevenue.vue?vue&type=script&lang=js&"
import style0 from "./TotalSalesRevenue.vue?vue&type=style&index=0&id=08eb81f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb81f4",
  null
  
)

component.options.__file = "TotalSalesRevenue.vue"
export default component.exports